import * as damWebSocketActionTypes from '../../consts/dam/damWebSocketActionTypes';
import uamStatusTypes from '../../consts/uam/uamStatusTypes';
import * as uamWebSocketEventTypes from '../../consts/uam/uamWebSocketEventTypes';
import {selectIotDeviceData} from '../../state/selectors/iotDevices';
import {setDeviceConnectionStatus, updateDeviceData, updateDeviceFirmwareData} from '../../state/slice/iotDevices';
import {updateRetailDeviceData} from '../../state/slice/retail';
import {dispatch, getState} from '../../state/store';
import objectUtil from '../../utils/objectUtil';
import valueUtils from '../../utils/valueUtils';
import log from '../logger/log';
import uamAsyncRequestService from './uamAsyncRequestService';
import uamMappingService from './uamMappingService';

const proceedMessage = (message) => {
    const data = JSON?.parse(message.data) || {};
    const {eventType, status, serialNumber} = data || {};

    switch (eventType) {
        case uamWebSocketEventTypes.CONNECTION_STATUS_CHANGE:
            proceedConnectionChange(serialNumber, status);
            break;
        case uamWebSocketEventTypes.ASYNC_REQUEST:
            manageAsyncRequestMessage(data);
            break;
        case uamWebSocketEventTypes.DEVICE_DATA_CHANGE:
            manageDeviceDataChangeMessage(data);
            break;
        case uamWebSocketEventTypes.RETAIL_CONNECTION_STATUS_CHANGE:
            manageRetailConnectionStatusChangeMessage(data);
            break;
        default:
            break;
    }
};

const manageAsyncRequestMessage = (data) => {
    const {request} = data || {};
    const {action} = request || {};

    uamAsyncRequestService.completeRequest(data);

    switch (action) {
        case damWebSocketActionTypes.FIRMWARE_UPDATE_PROGRESS:
            proceedFirmwareProgress(data);
            break;
        case damWebSocketActionTypes.FIRMWARE_UPGRADE:
            proceedFirmwareUpgrade(data);
            break;
        default:
            break;
    }
};

const manageDeviceDataChangeMessage = (data) => {
    const {serialNumber, updatedData} = data || {};
    const newDeviceAsset = uamMappingService.getDeviceFields(updatedData);

    dispatch(updateDeviceData(serialNumber, newDeviceAsset));
};

const proceedConnectionChange = (dusn, status) => {
    const mappedStatus = uamMappingService.normalizeConnectionStatus(status);

    dispatch(setDeviceConnectionStatus(dusn, mappedStatus));
};

const proceedFirmwareProgress = (data = {}) => {
    const {serialNumber, request, requestId} = data;
    const deviceData = selectIotDeviceData(serialNumber)(getState());

    if (!deviceData) {
        log.warn(`Device [${serialNumber}] not found to proceed firmware update state`, null, serialNumber);
    }

    const newFwuData = objectUtil.filterUndefined({
        status: uamStatusTypes.RUNNING,
        progress: valueUtils.parseToNumber(request?.value?.phaseProgress),
        requestId,
    });

    dispatch(updateDeviceFirmwareData(serialNumber, newFwuData));
};

const proceedFirmwareUpgrade = (data) => {
    const {serialNumber, status, request} = data;
    const deviceData = selectIotDeviceData(serialNumber)(getState());

    if (!deviceData) {
        log.warn(`Device [${serialNumber}] not found to proceed firmware update status`, null, serialNumber);
    }

    const installedFWVersion = request?.resultMetadata?.firmwareStatus?.installedFWVersion;

    dispatch(updateDeviceFirmwareData(serialNumber, {status}));

    if (installedFWVersion) {
        dispatch(updateDeviceData(serialNumber, {device: {firmwareVersion: installedFWVersion}}));
    }
};

const manageRetailConnectionStatusChangeMessage = (data) => {
    const {deviceId: serialNumber, status: onboardingStatus} = data;

    dispatch(updateRetailDeviceData(serialNumber, {onboardingStatus}));
};

export default {
    proceedMessage,
};
